<ng-container *ngIf="type === 'list'; else cardTemplate">
  <span [ngClass]="['stripe', 'stripe-' + theme, 'stripe-' + size]"></span>
</ng-container>

<ng-template #cardTemplate>
  <span [ngClass]="['stripe-card', 'stripe-' + theme, 'stripe-' + size]"></span>
</ng-template>
